export const SET_SLIDE_SUB_MENU = 'SET_SLIDE_SUB_MENU'
export const SET_CURRENT_CATEGORY = 'SET_CURRENT_CATEGORY'
